import { Notification, NotificationParams } from '@core/models/notification.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class NotificationService {
    private readonly getAllNotificationsURL = `/notifications/all-notification`;
    private readonly markAsReadURL = `/notifications`;
    private readonly markAllAsReadURL = `/notifications/read-all`;
    private readonly markAsUnreadURL = `/notifications`;

    // ---------------------------------------------------------------

    getAllNotifications(params?: NotificationParams) {
        return fetchWithRetry(API.get<Notification[]>(this.getAllNotificationsURL, { params }));
    }

    markAsRead(id: number) {
        return fetchWithRetry(API.post(`${this.markAsReadURL}/${id}/read`));
    }

    markAllAsRead() {
        return fetchWithRetry(API.post(this.markAllAsReadURL));
    }

    markAsUnread(id: number) {
        return fetchWithRetry(API.post(`${this.markAsUnreadURL}/${id}/unread`));
    }
}

export default new NotificationService();

